import pkg from "../../package.json";
export const aConfigUrl = () => {
  // config use for OKTA Admin Dashboard
  if (process.env.REACT_APP_ENV.trim() === "dev_sit") {
    return {
      Phase: "localhost",
      TextPhase: "localhost_sit",
      issuer: "https://principal-poc.okta.com/oauth2/ausf2c9hxS0KHQmKl3l6",
      clientId: "0oaj5mu94YmngL2t13l6",
      discoveryUri:
        "https://principal-poc.okta.com/oauth2/ausf2c9hxS0KHQmKl3l6",
      pkce: true,
      redirectUri: "http://localhost:3000/authService/callback",
      logoutOktaUri: "https://principal-poc.okta.com/login/signout",
      logoutUri: "https://app.dev.principal.th/logout",
      Version: `v.${pkg.version}` 
    };
  } else if (process.env.REACT_APP_ENV.trim() === "dev_uat") {
    return {
      Phase: "localhost",
      TextPhase: "localhost_uat",
      issuer: "https://accounts.app.staging.principal.th/oauth2/ausle36ppYEjZp1tj756",
      clientId: "0oale4x2fCAXagewO756",
      discoveryUri:
        "https://accounts.app.staging.principal.th/oauth2/ausle36ppYEjZp1tj756",
      pkce: true,
      redirectUri: "http://localhost:3000/authService/callback",
      logoutOktaUri: "https://principal.oktapreview.com/login/signout",
      logoutUri: "https://app.staging.principal.th/logout",
      Version: `v.${pkg.version}` 
    };
  } else if (process.env.REACT_APP_ENV.trim() === "production") {
     //real production 
    return {
      Phase: "PRO",
      TextPhase: "production",
      issuer: "https://accounts.app.principal.th/oauth2/ausmmf70eSlAgwk2w756",
      clientId: "0oaqnuhqmHzIXrvaL756",
      discoveryUri:
        "https://accounts.app.principal.th/oauth2/ausmmf70eSlAgwk2w756",
      pkce: true,
      redirectUri: "https://app.principal.th/authService/callback",
      logoutOktaUri: "https://principal-ciam1.okta.com/login/signout",
      logoutUri: "https://app.principal.th/logout",
      Version: `v.${pkg.version}`,
      scopes: ['openid', 'profile', 'offline_access'],
    };
  } else if (process.env.REACT_APP_ENV.trim() === "uat") {
    return {
      Phase: "UAT",
      TextPhase: "UAT",
      issuer: "https://accounts.app.staging.principal.th/oauth2/ausle36ppYEjZp1tj756",
      clientId: "0oale4x2fCAXagewO756",
      discoveryUri:
        "https://accounts.app.staging.principal.th/oauth2/ausle36ppYEjZp1tj756",
      pkce: true,
      redirectUri:
        "https://app.staging.principal.th/authService/callback",
      logoutOktaUri: "https://accounts.app.staging.principal.th/login/signout",
      logoutUri: "https://app.staging.principal.th/logout",
      Version: `v.${pkg.version}`,
      scopes: ['openid', 'profile', 'offline_access'],
    };
  } else {
      return {
        Phase: "SIT",
        TextPhase: "SIT",
        issuer: "https://accounts.app.dev.principal.th/oauth2/ausk7up583OhC5z5c1d7",
        clientId: "0oakle9s6yR5kkxFZ1d7",
        discoveryUri:
          "https://accounts.app.dev.principal.th/oauth2/ausk7up583OhC5z5c1d7",
        pkce: true,
        redirectUri:
          "https://app.dev.principal.th/authService/callback",
          logoutOktaUri: "https://accounts.app.dev.principal.th/login/signout",
        logoutUri: "https://app.dev.principal.th/logout",
        Version: `v.${pkg.version}`,
        scopes: ['openid', 'profile', 'offline_access'],
      };
  }
};
